import { Navigate } from "react-router-dom";
import { TEAM_BASE } from "./teamConstants";

/** Маршрут сохранён для прямых ссылок — открывает модалку на списке команды. */
export default function AdminTeamInvite() {
  return <Navigate to={`${TEAM_BASE}?invite=1`} replace />;
}
